<template>
    <div v-bind:id="internalId">
        <div v-if="label">
            <pc-label
                v-if="label"
                v-bind="labelBinder"
                v-bind:for-id="null"
                v-on:help-clicked="$emit('help-clicked')" />
        </div>
        <slot name="afterLabel" />
        <fieldset>
            <legend class="visually-hidden">
                {{ label || altLabel }}
            </legend>
            <div v-bind:class="containerClasses">
                <div
                    v-for="(option, index) in options"
                    v-bind:key="index"
                    v-bind:class="getItemClasses(index)"
                    class="form-check">
                    <input
                        v-bind:id="optionIds[index]"
                        v-model="internalValue"
                        v-bind:disabled="disabled || readonly"
                        v-bind:value="option[valueProp]"
                        v-bind:name="nameOverride"
                        v-bind:class="inputClasses"
                        v-bind:data-test-role="testRole"
                        v-bind:data-test-value="option[textProp]"
                        class="form-check-input"
                        type="radio"
                        v-on="listeners" />
                    <label
                        v-bind:for="optionIds[index]"
                        class="form-check-label">
                        {{ option[textProp] }}
                    </label>
                </div>
            </div>
        </fieldset>
        <div
            v-if="showValidationErrors && validationError"
            class="invalid-feedback d-block fw-bold">
            {{ validationError }}
        </div>
    </div>
</template>

<script>
    import base from "./_inputBase.vue";
    export default {
        extends: base,
        props: {
            modelValue: { type: [String, Number], required: false, default: null },
            options: { type: Array, required: true },
            valueProp: { type: String, required: false, default: "value" },
            textProp: { type: String, required: false, default: "text" },
            name: { type: String, required: true },
            inline: { type: Boolean, required: false, default: false }
        },
        emits: ["help-clicked"],
        computed: {
            optionIds() {
                return this.options.map((o) => `${this.internalId}_${o[this.valueProp]}`);
            },
            containerClasses() {
                return this.inline ? "d-flex align-items-center" : "";
            },
            // If no test role specified for the individual buttons, just reuse the parent ID
            testRole() {
                if (this.binder["data-test-role"] != null) {
                    return this.binder["data-test-role"];
                }
                return this.internalId;
            },
            // Avoid non-unique names for multiple input groups by appending
            // internalId to name. Can arise if a radio-group is part of a component
            // of which there can be multiple copies on a page
            nameOverride() {
                return `${this.internalName}_${this.internalId}`;
            }
        },
        methods: {
            getItemClasses(index) {
                if (!this.inline || index > 0) {
                    return "ms-3";
                }
            }
        }
    };
</script>
